import * as React from 'react';

import FileAudio32 from './FileAudio32';

export const fileAudio32 = () => <FileAudio32 />;

export default {
    title: 'Icon/Content/FileAudio32',
    component: FileAudio32,
    parameters: {
        notes: "`import FileAudio32 from 'box-ui-elements/es/icon/content/FileAudio32';`",
    },
};
